// Every chli-component script, in the same (alphabetical) order as the former
// `import '../chli-components/**/*.js'` glob in site/main.ts, except the ones
// that common/js/lazy-components.js starts on demand (still in this bundle).
const ON_DEMAND = /^\.\/(blogstories|mediaCenter|seasonalBanner|whatisLifeInsurance)\//;
const components = require.context("./", true, /^\.\/[^/]+\/.+\.js$/);

components
    .keys()
    .filter((key) => !ON_DEMAND.test(key))
    .sort((a, b) => a.localeCompare(b, "en"))
    .forEach(components);
